import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import type { FormField, ThankYouScreenConfig, ThemeConfig } from '../../../types/forms';

interface ThankYouScreenFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- themeConfig reservado pra futuro uso (OQ1=b Pax); icons semânticos intocados (OQ2=a)
export const ThankYouScreenField: React.FC<ThankYouScreenFieldProps> = ({ field, themeConfig: _themeConfig }) => {
  const config = field.config as ThankYouScreenConfig | undefined;

  return (
    <div className="py-6">
      <div className="w-16 h-16 mx-auto bg-green-500/20 rounded-full flex items-center justify-center mb-4">
        <CheckCircle2 className="w-8 h-8 text-green-400" />
      </div>
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: 'inherit' }}>{field.label}</h2>
      {field.helpText && (
        <p className="mb-8 text-lg" style={{ color: 'inherit', opacity: 0.6 }}>{field.helpText}</p>
      )}
      {config?.redirectDelay && (
        <p className="text-sm text-neutral-500">
          Redirecionando em {config.redirectDelay}s...
        </p>
      )}
    </div>
  );
};
